import React from 'react';
import PropTypes from 'prop-types';
import { useInstantSearch } from 'react-instantsearch';
import { Picture } from '../../../ui/Picture';

export default function ProductHit({
  hit,
  additionalData,
}) {
  const {
    id,
    title,
    url,
    productImages,
    version,
    subtitle,
  } = hit;

  const { translates } = additionalData;
  const { catalog } = translates;

  const { results } = useInstantSearch();
  const hitIndex = results.hits.findIndex((h) => h.id === id);
  const lazyLoadImage = hitIndex > 9;

  return (
    <div className="col-12 col-sm-6 col-lg-4 d-flex mb-2b mb-lg-4a">
      <a className="card-product" href={url}>
        <div className="card-product-img">
          {productImages?.length > 0 && (
            <Picture image={productImages?.[0]} alt={title} defaultTransform="xl-min" loading={lazyLoadImage ? 'lazy' : 'eager'} fetchPriority={lazyLoadImage ? 'auto' : 'high'} />
          )}
        </div>
        <div className="card-product-body">
          <h3>{title}</h3>
          <span className="exception">
            {subtitle ?? (Craft.canViewReleaseNotes && version && (Craft.t(catalog, 'Version {version}', { version })))}
          </span>
        </div>
      </a>
    </div>
  );
}

ProductHit.propTypes = {
  hit: PropTypes.shape({
    id: PropTypes.number,
    title: PropTypes.string,
    url: PropTypes.string,
    productImages: PropTypes.arrayOf(PropTypes.shape({
      url: PropTypes.string,
    })),
    version: PropTypes.string,
    subtitle: PropTypes.string,
  }),
  additionalData: PropTypes.objectOf(PropTypes.any),
};
